export default __webpack_public_path__ + "static/media/twitter-x-logo.2254c42b.png";